import { ROUTES } from 'views/Configure/stubs';

const BASE_URL = ROUTES.REQUEST_REASONS;

export default {
  ROOT: BASE_URL,
  CREATE_REASON: `${BASE_URL}/create`,
  EDIT_REASON: `${BASE_URL}/:id/edit`
};
